import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Add, ArrowBack, Done, Edit } from "@mui/icons-material";
import { MainContext } from "../../../../../Context/MainCtx";
import { useMutation } from "@apollo/client";
import {
  ACTUALIZAR_TIPO_ACTIVIDAD,
  CREAR_TIPO_ACTIVIDAD,
} from "../graphql/mutations";
import { CircularProgress } from "@mui/material";
import IconSelect from "./IconSelect";

const initial_tipo = {
  tipoActividad: "",
  accion: "",
  icono: "",
};

export default function NuevoTipoActividad({
  edit,
  data,
  refetch,
  external = false,
  refetchExternal = null,
}) {
  const [open, setOpen] = React.useState(false);
  const [tipoActividad, setTipoActividad] = React.useState(initial_tipo);
  const [loading, setLoading] = React.useState(false);
  const { snackMessage, tokenDecoded } = React.useContext(MainContext);
  const [crearTipoActividad] = useMutation(CREAR_TIPO_ACTIVIDAD);
  const [actualizarTipoActividad] = useMutation(ACTUALIZAR_TIPO_ACTIVIDAD);

  const handleOpen = () => {
    setOpen(true);
    if (edit) {
      const { _id, idEmpresa, ...newData } = data;
      setTipoActividad(newData);
    }
  };
  const handleClose = () => {
    setOpen(false);
    setTipoActividad(initial_tipo);
  };

  const handleChangeTipo = (e) => {
    const { name, value } = e.target;
    setTipoActividad((st) => ({ ...st, [name]: value }));
  };

  const handleSaveTipoActividad = async (e) => {
    try {
      e.stopPropagation();
      e.preventDefault();
      setLoading(true);
      const input = { ...tipoActividad };
      if (!edit) {
        //si es nuevo
        const res = await crearTipoActividad({
          variables: {
            idEmpresa: tokenDecoded ? tokenDecoded.idEmpresa : "",
            input,
          },
        });
        snackMessage({
          message: res.data.crearTipoActividad.message,
          variant: "success",
        });
      } else {
        //si va a actualizar
        const res = await actualizarTipoActividad({
          variables: {
            idTipoActividad: data._id,
            idEmpresa: tokenDecoded ? tokenDecoded.idEmpresa : "",
            input,
          },
        });
        snackMessage({
          message: res.data.actualizarTipoActividad.message,
          variant: "success",
        });
      }
      if (external && refetchExternal) refetchExternal();
      if (refetch) refetch();
      setLoading(false);
      handleClose();
    } catch (err) {
      setLoading(false);
      snackMessage({
        message: err.message ? err.message : "Error Desconocido",
        variant: "error",
      });
    }
  };

  return (
    <div>
      {edit ? (
        <IconButton onClick={handleOpen}>
          {loading ? <CircularProgress size={20} color="inherit" /> : <Edit />}
        </IconButton>
      ) : external ? (
        <IconButton onClick={handleOpen} size="small" color="primary">
          <Add />
        </IconButton>
      ) : (
        <Button
          onClick={handleOpen}
          color="primary"
          variant="contained"
          size="small"
          disableElevation
          sx={{ textTransform: "none" }}
          startIcon={<Add />}
        >
          Nuevo
        </Button>
      )}
      <Drawer
        anchor="right"
        open={open}
        onClose={handleClose}
        ModalProps={{
          componentsProps: {
            backdrop: {
              sx: { background: "none" },
            },
          },
        }}
        PaperProps={{
          elevation: 1,
          sx: { width: { xs: "100vw", md: "40vw" } },
        }}
      >
        <Toolbar variant="dense" />
        <DialogTitle>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton onClick={() => handleClose()}>
              <ArrowBack />
            </IconButton>
            <Box sx={{ ml: 1 }} />
            <Typography variant="h6">
              {edit ? `Editar` : "Nuevo tipo"}
            </Typography>
            <Box sx={{ flexGrow: 1 }} />
            <Button
              startIcon={
                loading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <Done />
                )
              }
              variant="contained"
              size="small"
              sx={{ textTransform: "none" }}
              disableElevation
              type="submit"
              form="formTipoAct"
            >
              Guardar
            </Button>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ py: 0 }}>
          <form id="formTipoAct" onSubmit={handleSaveTipoActividad}>
            <IconSelect
              tipoActividad={tipoActividad}
              setTipoActividad={setTipoActividad}
            />
            <TextField
              label="Tipo actividad"
              name="tipoActividad"
              size="small"
              variant="outlined"
              margin="dense"
              fullWidth
              required
              value={tipoActividad.tipoActividad}
              onChange={handleChangeTipo}
            />
            <TextField
              label="Acción"
              name="accion"
              size="small"
              variant="outlined"
              margin="dense"
              fullWidth
              required
              value={tipoActividad.accion}
              onChange={handleChangeTipo}
            />
          </form>
        </DialogContent>
      </Drawer>
    </div>
  );
}
